import { useNavigate } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import AddEmployeeModal from 'modules/work_schedules/components/AddEmployeesModal'
import { canAssignEmployees } from 'modules/work_schedules/lib/canAssignEmployees'
import schedules from 'modules/work_schedules/store/collections/schedules'

const AddEmployeeModalPage = () => {
  const { navigation } = useNavigation()

  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()
  const workScheduleId = Number(id)

  const onClose = () => {
    navigate(navigation.settings.workSchedule.id.employees.fullPath({ id: workScheduleId }))
  }

  const onSuccess = async () => {
    await Promise.all([schedules.fetch(), employees.fetch()])

    navigate(navigation.settings.workSchedule.id.employees.fullPath({ id: workScheduleId }))
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  const workSchedule = schedules.get(workScheduleId)

  if (loading) {
    return <Loading />
  }

  return workSchedule ? (
    <AuthorizeUser authorizeFn={() => canAssignEmployees(contractVersions)}>
      <AddEmployeeModal
        workSchedule={workSchedule}
        onClose={onClose}
        onSuccess={onSuccess}
        contractVersions={contractVersions}
      />
    </AuthorizeUser>
  ) : null
}

export default AddEmployeeModalPage
